<template>
  <details v-if="image.ai_tag_result_id" class="ai-review-summary">
    <summary>审核差异 · {{ changedCount }} 项变化<span v-if="reasons.length"> · 需重点审核</span></summary>
    <div v-if="reasons.length" class="review-warning">{{ reasons.join('；') }}</div>
    <p v-if="image.ai_review?.visual_summary">AI 看到：{{ image.ai_review.visual_summary }}</p>
    <div v-for="row in rows" :key="row.field" class="review-field">
      <strong>{{ row.label }}{{ row.changed ? '（变化）' : '（不变）' }}</strong>
      <div>原有：{{ names(row.field, row.before) }}</div>
      <div>接受后：{{ names(row.field, row.after) }}</div>
      <div v-if="row.abstained" class="review-warning">AI 未给出匹配建议，请人工核对；已有值保留。</div>
      <div v-if="row.corrected" class="review-warning">规则调整：{{ names(row.field, row.raw) }} → {{ names(row.field, row.suggested) }}</div>
    </div>
  </details>
</template>
<script>
import {aiReviewComparison, aiReviewReasons} from '../libs/aiTagWorkflow.mjs';
export default {
  name: 'AiTagReviewSummary',
  props: {image: {type: Object, required: true}, maps: {type: Object, default: () => ({})}},
  computed: {
    rows() { return aiReviewComparison(this.image); },
    changedCount() { return this.rows.filter(row => row.changed).length; },
    reasons() { return aiReviewReasons(this.image); },
  },
  methods: {names(field, values) { return values.length ? values.map(value => this.maps[field]?.[value] || value).join('、') : '空'; }},
};
</script>
<style scoped>
.ai-review-summary { line-height: 1.6; margin: 8px 0; padding: 6px; background: #f5f7fa; border-radius: 4px; }
summary { cursor: pointer; color: #305f97; }
p { margin: 6px 0; }
.review-field { border-top: 1px solid #e4e7ed; padding: 5px 0; }
.review-warning { color: #996300; }
</style>
